/* global axios */
import ApiClient from './ApiClient';

class TicketsAPI extends ApiClient {
  constructor() {
    super('tickets', { accountScoped: true });
  }

  index(params = {}) {
    return axios.get(this.url, { params });
  }

  statuses() {
    return axios.get(`${this.baseUrl()}/ticket_statuses`);
  }

  categories() {
    return axios.get(`${this.baseUrl()}/ticket_categories`);
  }

  configuration() {
    return axios.get(
      `${this.baseUrl()}/ticket_configuration`
    );
  }

  updateConfiguration(data) {
    return axios.patch(
      `${this.baseUrl()}/ticket_configuration`,
      {
        ticket_configuration: data,
      }
    );
  }

  createStatus(data) {
    return axios.post(
      `${this.baseUrl()}/ticket_statuses`,
      {
        ticket_status: data,
      }
    );
  }

  updateStatus(id, data) {
    return axios.patch(
      `${this.baseUrl()}/ticket_statuses/${id}`,
      {
        ticket_status: data,
      }
    );
  }

  deleteStatus(id) {
    return axios.delete(
      `${this.baseUrl()}/ticket_statuses/${id}`
    );
  }

  createCategory(data) {
    return axios.post(
      `${this.baseUrl()}/ticket_categories`,
      {
        ticket_category: data,
      }
    );
  }

  updateCategory(id, data) {
    return axios.patch(
      `${this.baseUrl()}/ticket_categories/${id}`,
      {
        ticket_category: data,
      }
    );
  }

  deleteCategory(id) {
    return axios.delete(
      `${this.baseUrl()}/ticket_categories/${id}`
    );
  }

  convertConversation(conversationId, data = {}) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/ticket`,
      {
        ticket: data,
      }
    );
  }

  createMessage(ticketId, payload) {
  return axios.post(
    `${this.url}/${ticketId}/messages`,
    payload
  );
}

createNote(ticketId, payload) {
  return axios.post(
    `${this.url}/${ticketId}/notes`,
    payload
  );
}

changeStatus(ticketId, statusId) {
    return axios.post(`${this.url}/${ticketId}/status`, {
      ticket: {
        status_id: statusId,
      },
    });
  }
  integrations() {
    return axios.get(
      `${this.baseUrl()}/ticket_integrations`
    );
  }

  updateIntegration(id, data) {
    return axios.patch(
      `${this.baseUrl()}/ticket_integrations/${id}`,
      {
        ticket_integration: data,
      }
    );
  }


  teams() {
    return axios.get(
      `${this.baseUrl()}/teams`
    );
  }

  departmentMailSettings() {
    return axios.get(
      `${this.baseUrl()}/ticket_department_mail_settings`
    );
  }

  createDepartmentMailSetting(data) {
    return axios.post(
      `${this.baseUrl()}/ticket_department_mail_settings`,
      {
        ticket_department_mail_setting: data,
      }
    );
  }

  updateDepartmentMailSetting(id, data) {
    return axios.patch(
      `${this.baseUrl()}/ticket_department_mail_settings/${id}`,
      {
        ticket_department_mail_setting: data,
      }
    );
  }

  deleteDepartmentMailSetting(id) {
    return axios.delete(
      `${this.baseUrl()}/ticket_department_mail_settings/${id}`
    );
  }

}

export default new TicketsAPI();
